import React from 'react'
import styled from 'styled-components'
import {
  Modal as AntModal,
  ModalFooter,
} from 'reactstrap'
import { IoIosCloseCircle } from 'react-icons/io'

import { BillingDetail } from './billing-detail'
import { ListDetail } from './list-detail'
import { Button } from '../../../../buttons'
import { CustomSearchSelect } from '../../../../input'
import { FONTS } from '../../../../../constants'
import { piStatusOptions, statusOptions } from '../constants'

export const ViewBilling = ({
  isView,
  data = {},
  handleClose,
  interpretBillingType,
  revenueAllocation,
  projectRevenue,
  projectAvailable,
  editingBillings,
}) => {
  const _status = statusOptions.find(s => s.value === data.status) || null

  return (
    <Modal
      size='lg'
      isOpen={ isView }
      toggle={ handleClose }
    >
      <ModalHeader toggle={ handleClose }>
        <HeaderText>View Billing Milestone</HeaderText>
        <AlignCenterWrapper>
          <StatusText>Status</StatusText>
          <DrodownWrapper>
            <CustomSearchSelect
              isDisabled
              placeholder='Select Status'
              options={ piStatusOptions }
              value={ _status }
            />
          </DrodownWrapper>
          <IoIosCloseCircle onClick={ handleClose } />
        </AlignCenterWrapper>
      </ModalHeader>

      <BodyWrapper>
        <BillingDetail
          detailState={ data }
          projectRevenue={ projectRevenue }
          projectAvailable={ projectAvailable }
        />
        <ListDetail
          detailState={ data }
          revenueAllocation={ revenueAllocation }
          interpretBillingType={ interpretBillingType }
          editingBillings={ editingBillings }
        />
      </BodyWrapper>

      <ModalFooter>
        <ButtonWrapper>
          <Button
            theme='#6c757d'
            width='70px'
            height='26px'
            onClick={ handleClose }
          >
                Close
          </Button>
        </ButtonWrapper>
      </ModalFooter>
    </Modal>
  )
}

const Modal = styled(AntModal)`
  .modal-header {
    border: none;
  }

  .modal-footer {
    border: none;
    background: #F9F9F9;
  }
`

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 16px 0 16px;

  svg {
      font-size: 24px;
      color: #C4C4C4;
      cursor: pointer;
  }
`

const DrodownWrapper = styled.div`
  width: 150px;
  display: flex;
  align-items: center;
  margin: 0 16px;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 500px;
  max-height: 500px;
  overflow-y: scroll;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 28px 16px 0 16px;
`

const Row = styled.div`
  display: flex;
`

const ButtonWrapper = styled(Row)`
  justify-content: flex-end;
  flex: 1;
`

const AlignCenterWrapper = styled(Row)`
  height: 100%;
  align-items: center;
`

const StatusText = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-billing/view-billing/index.js